module.exports = __webpack_public_path__ + "d9a8bca5e7d1f328179ae371d0d5006e.png";